<template>
    <div class="optpl-templates__container">
        <div class="optpl-templates__group">
            <div class="optpl-templates__group-heading">
                <h3 class="opui-skeleton-shimmer" style="max-width: 420px;">Templates</h3>
                <h4 class="opui-skeleton-shimmer" style="max-width: 720px;">Lorem</h4>
            </div>

            <div class="optpl-templates__list">
                <ul>
                    <li v-for="template in templates">
                        <div class="optpl-template-item optpl-template-item__template">
                            <figure class="opui-skeleton-shimmer"><img alt=""></figure>

                            <div class="optpl-template-item__text">
                                <h4 class="opui-skeleton-shimmer">Lorem ipsum</h4>
                                <div class="opui-skeleton-shimmer">Lorem ipsum.</div>
                                <div class="opui-skeleton-shimmer">Lorem ipsum.</div>
                                <div class="opui-skeleton-shimmer" style="width: 60%;">Lorem ipsum.</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            templates: 12,
        }
    }
}
</script>
<style lang="scss" scoped>
.box:hover {
    .details, .title, .description {
        display: block !important;
    }
}
</style>
